import styles from './parts.module.css';

const StatusPill = ({ tone = 'neutral', children }) => (
    <span className={`${styles.pill} ${styles[tone]}`}>{children}</span>
);

export default StatusPill;
